import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { UserManagementService } from '../../user-management/services/user-management.service';

@Pipe({
    name: 'user',
    standalone: true
})
export class UserPipe implements PipeTransform {
    constructor(private userService: UserManagementService) {}

    transform(value: string | undefined): Observable<string> {
        if (!value) {
            return of('');
        }

        const trimmedValue = value?.trim();
        if (this.isGid(trimmedValue)) {
            return this.userService.getUser(trimmedValue).pipe(
                map(user => `${user.firstName} ${user.lastName}`),
                startWith(trimmedValue)
            );
        }
        return of(value);
    }

    private isGid(value: string): boolean {
        return /^[Z|X][A-Z0-9]{7}$/.test(value.toUpperCase());
    }
}
